<!--
  A flex column the height of the dialog surface: the header and the footer keep
  their own height and the tab strip's content takes what is left, so a step
  taller than the dialog scrolls inside the tab instead of running underneath the
  footer.
-->
<div class="new-patient-dialog flex h-full flex-col overflow-hidden">
  <!-- Header -->
  <div
    class="flex shrink-0 justify-center items-center h-20 bg-primary-light border-b"
  >
    <h2 class="flex text-xl text-accent mx-auto font-bold items-center">New Patient     <mat-spinner class="ml-1" *ngIf="loading"  class="m-10px white-spinner" [diameter]="20"></mat-spinner> </h2>

    <div class="mb-auto">
      <button mat-icon-button class="btm-sm mr-5 my-2 " (click)="onClose()">
        <mat-icon class="text-accent">close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Tabs -->
  <mat-tab-group
    class="min-h-0 flex-1"
    (selectedIndexChange)="onStepChange($event)"
    [selectedIndex]="currentStep"
  >
    <mat-tab
      [disabled]="!canAdvanceToStep(0)"
      [class.completed-tab]="isStepValid(0)"
    >
      <ng-template mat-tab-label>
        <div
          [class.completed-tab]="isStepValid(0)"
          class="flex items-center gap-3"
        >
          <!-- This div will transform when selected -->
          <div
            class="tab-number relative flex items-center justify-center w-7 h-7 rounded-full bg-divider p-[2px]"
            [class.step-error]="stepHasError(0)"
          >
            <div
              class="flex items-center justify-center w-full h-full rounded-full"
            >
              <div
                class="flex items-center justify-center w-5 h-5 rounded-full text-md text-muted font-medium"
              >
                <mat-icon
                  *ngIf="stepHasError(0)"
                  class="step-error__icon"
                  >error_outline</mat-icon
                >
                <ng-container *ngIf="!stepHasError(0)">{{
                  !completedSteps[0] ? "1" : "✓"
                }}</ng-container>
              </div>
            </div>
          </div>
          <span
            class="text-xs"
            [class.step-error__label]="stepHasError(0)"
            >Main Info</span
          >
        </div>
      </ng-template>
      <app-patient-main-info
        (mainFormValue)="getForm($event)"
        [patientData]="data"
        [researchConsentEnabled]="researchConsentEnabled"
        [serverErrors]="serverErrors.mainInfo || null"
        (departmentSelected)="onPatientDepartmentChange($event)"
      ></app-patient-main-info>
    </mat-tab>

    <mat-tab
      [disabled]="!canAdvanceToStep(1)"
      [class.completed-tab]="isStepValid(1)"
    >
      <ng-template mat-tab-label>
        <div
          [class.completed-tab]="isStepValid(1)"
          class="flex items-center gap-3"
        >
          <div
            class="tab-number relative flex items-center justify-center w-7 h-7 rounded-full bg-divider p-[2px]"
            [class.step-error]="stepHasError(1)"
          >
            <div
              class="flex items-center justify-center w-full h-full rounded-full"
            >
              <div
                class="flex items-center justify-center w-5 h-5 rounded-full text-muted text-md font-medium"
              >
                <mat-icon
                  *ngIf="stepHasError(1)"
                  class="step-error__icon"
                  >error_outline</mat-icon
                >
                <ng-container *ngIf="!stepHasError(1)">{{
                  !completedSteps[1] ? "2" : "✓"
                }}</ng-container>
              </div>
            </div>
          </div>
          <span
            class="text-xs"
            [class.step-error__label]="stepHasError(1)"
            >Additional Info</span
          >
        </div>
      </ng-template>
      <app-patient-add-info
        (additionalFormValue)="getForm($event)"
        [patientData]="data"
      ></app-patient-add-info>
    </mat-tab>

    <mat-tab
      [disabled]="!canAdvanceToStep(2)"
      [class.completed-tab]="isStepValid(2)"
    >
      <ng-template mat-tab-label>
        <div
          [class.completed-tab]="isStepValid(2)"
          class="flex items-center gap-3"
        >
          <div
            class="tab-number relative flex items-center justify-center w-7 h-7 rounded-full bg-divider p-[2px]"
            [class.step-error]="stepHasError(2)"
          >
            <div
              class="flex items-center justify-center w-full h-full rounded-full"
            >
              <div
                class="flex items-center justify-center w-5 h-5 rounded-full text-muted text-md font-medium"
              >
                <mat-icon
                  *ngIf="stepHasError(2)"
                  class="step-error__icon"
                  >error_outline</mat-icon
                >
                <ng-container *ngIf="!stepHasError(2)">{{
                  !completedSteps[2] ? "3" : "✓"
                }}</ng-container>
              </div>
            </div>
          </div>
          <span
            class="text-xs"
            [class.step-error__label]="stepHasError(2)"
            >Comments</span
          >
        </div>
      </ng-template>
      <app-patient-add-comment
        (commentFormValue)="getForm($event)"
        [patientData]="data"
      ></app-patient-add-comment>
    </mat-tab>

    <mat-tab
      [disabled]="!canAdvanceToStep(3)"
      [class.completed-tab]="isStepValid(3)"
    >
      <ng-template mat-tab-label>
        <div
          [class.completed-tab]="isStepValid(3)"
          class="flex items-center gap-3"
        >
          <div
            class="tab-number relative flex items-center justify-center w-7 h-7 rounded-full bg-divider p-[2px]"
            [class.step-error]="stepHasError(3)"
          >
            <div
              class="flex items-center justify-center w-full h-full rounded-full"
            >
              <div
                class="flex items-center justify-center w-5 h-5 rounded-full text-muted text-md font-medium"
              >
                <mat-icon
                  *ngIf="stepHasError(3)"
                  class="step-error__icon"
                  >error_outline</mat-icon
                >
                <ng-container *ngIf="!stepHasError(3)">{{
                  !completedSteps[3] ? "4" : "✓"
                }}</ng-container>
              </div>
            </div>
          </div>
          <span
            class="text-xs"
            [class.step-error__label]="stepHasError(3)"
            >Assign Device</span
          >
        </div>
      </ng-template>
      <app-devices-selector
        [className]="'patient-dialog'"
        (deviceFormValue)="getForm($event)"
      ></app-devices-selector>
    </mat-tab>
  </mat-tab-group>

  <!-- Footer -->
  <div class="shrink-0 w-full flex justify-end border-t bg-white">
    <!-- Button for steps other than step 3 -->
    <button
    [disabled]="loading"
      *ngIf="currentStep !== 3"
      class="w-full"
      mat-flat-button
      color="primary"
      (click)="continueToNextStep(false)"
    >
      Continue to next step
    </button>

    <!-- Buttons for step 3 -->
    <div *ngIf="currentStep === 3" class="flex w-full">
      <button
      [disabled]="loading || !ability.canCreate(ability.subjects.Patient)"
        class="w-full rounded-control border border-solid border-divider-dark"
        mat-outlined-button
        color="primary"
        (click)="continueToNextStep(false)"
      >
        Save & Close >
      </button>
      <button
      [disabled]="loading || !ability.canCreate(ability.subjects.Patient)"
        class="w-full"
        mat-flat-button
        color="primary"
        (click)="continueToNextStep(true)"
      >
        + Add Other Patient
      </button>
    </div>
  </div>
</div>
